<template>
    <!-- <div class="box-dialog" v-if="dialogFormVisible"> -->
    <!-- <div v-if="dialogFormVisible" custom-class="box-dialog" class="box-dialog" fullscreen :visible.sync="dialogFormVisible" append-to-body="false" width="85%" height="650px" :close-on-click-modal="false" :close-on-press-escape="false"
        :show-close="false" title="档案信息"> -->
        <Basicform
v-if="dialogFormVisible" ref="basicform" :title="formTitle" :module-code="moduleInfo.moduleCode"
            :win-width="moduleInfo.winWidth" :win-height="moduleInfo.winHeight" :toolbar-btns="busiformBtns"
            :on-basic-form-before-open="onBasicFormBeforeOpen" :on-basic-form-opened="onBasicFormOpened"
            :on-basic-form-before-submit="onBasicFormBeforeSubmit" :on-basic-form-submited="onBasicFormSubmited"
>
            <template #default="slotProps">
                <busi-form ref="busiform" :vo="slotProps.vo" :can-edit="slotProps.canEdit" :module-info="moduleInfo" />
            </template>
        </Basicform>
    <!-- </div> -->
</template>

<script>
export default {
    data: function() {
        return {
            moduleInfo: {
                'formTemplate': 'dcontent/busiformurl?vwtype=W&url=/student/basicInfo/form.html',
                'addNewUrl': 'xsgl/studentBasicInfo/addNew',
                'insertUrl': 'xsgl/studentBasicInfo/insert',
                'getByIdUrl': 'xsgl/studentBasicInfo/getById',
                'updateUrl': 'xsgl/studentBasicInfo/update',
                'delUrl': 'xsgl/studentBasicInfo/delete',
                'listDataUrl': 'xsgl/studentBasicInfo/listdata',
                'winWidth': 1200,
                'winHeight': 600,
                'moduleCode': 'basicInfo',
                'openViewType': '0',
                'listAdvSearchAllFields': 0,
                'listAdvSearchExpandPanel': 0,
                'oldListDataUrl': '/xsgl/studentBasicInfo/listdata',
                'busiFormTemplate': '/student/basicInfo/form'
            },
            busiformBtns: [],
            formTitle: '学生基本信息表',
            // 当前登陆人
            loginUser: this.$store.getters.loginUser,
            vo: {},
            dialogFormVisible: false
        }
    },
    computed: {},
    watch: {
    },
    created: function() {
        let _this = this
        //列表页面配置ID
        //this.moduleInfo.listpageViewUrl = "/student/basicInfo/list.html"
        let formurl = _this.moduleInfo.formTemplate.split('url=')[1]
        formurl = formurl.replace(/\//g, '.')
        formurl = '#/dcontent/vuebusiform/W/' + formurl.substring(1).replace('.html', '.vue')
        formurl += '?sysCode=' + (_this.$route.meta.sysCode || '')
        _this.$options.components['BusiForm'] = _this.$loadComponent(formurl)

        _this.$bus.$on('showStudentFormDialog', () => {
            _this.dialogFormVisible = true
            _this.showForm()
        })
    },
    beforeDestroy: function() {
        this.$bus.$off('showStudentFormDialog')
    },
    mounted: function() {
    },
    methods: {
        showForm() {
            let _this = this
            _this.moduleInfo.formTemplate = 'dcontent/busiformurl?vwtype=W&url=/student/basicInfo/form.html'
            _this.moduleInfo.delUrl = '/xsgl/studentBasicInfo/delete'
            _this.moduleInfo.addNewUrl = '/xsgl/studentBasicInfo/addNew'
            _this.moduleInfo.insertUrl = '/xsgl/studentBasicInfo/insert'
            _this.moduleInfo.moduleCode = 'basicInfo'
            _this.moduleInfo.updateUrl = '/xsgl/studentBasicInfo/update'

            let formurl = _this.moduleInfo.formTemplate.split('url=')[1]
            formurl = formurl.replace(/\//g, '.')
            formurl = '#/dcontent/vuebusiform/W/' + formurl.substring(1).replace('.html', '.vue')
            formurl += '?sysCode=' + (this.$route.meta.sysCode || '')
            _this.$options.components['BusiForm'] = this.$loadComponent(formurl)
            // _this.showView="mainform";
            // _this.$emit('closeShow',1);
            _this.$nextTick(function() {
                _this.$bus.emit('openBusiform', _this.moduleInfo, null, 1)
            })
        },
        /**
             * 表单打开检查，vo为已加载basicInfo对象，允许打开：defer.resolve(true)，阻止打开：defer.reject(reason)
             */
        onBasicFormBeforeOpen: function($scope, vo, defer) {
            if (process.env.NODE_ENV === 'development') console.log('basicInfo form before open')
            defer.resolve(true)
        },
        /**
             * 表单打开完成，vo为已加载的basicInfo对象，前端页面dom对象已完成初始化、已经呈现，不需要返回值
             */
        onBasicFormOpened: function($scope, vo) {
            if (process.env.NODE_ENV === 'development') console.log('basicInfo form opened')
        },
        /**
             * 表单提交事件，可执行业务数据高级校验，vo为待提交的basicInfo对象，校验成功：defer.resolve(true)，校验失败：defer.reject(reason)
             */
        onBasicFormBeforeSubmit: function($scope, vo, defer) {
            /*this.$confirm('您是否确认提交保存?', '确认操作', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        defer.resolve(true)
                    })
                    .catch(err => {
                        defer.reject(err)
                    })*/

            if (process.env.NODE_ENV === 'development') console.log('basicInfo form submit validation success')
            defer.resolve(true)
        },
        /**
             * 表单提交完成，vo为已保存成功的basicInfo对象，窗口即将关闭，不需要返回值
             */
        onBasicFormSubmited: function($scope, vo) {
            if (process.env.NODE_ENV === 'development') console.log('basicInfo form submited')
        }

    }
}
</script>

<style scoped>
    .box-dialog {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        width: 100vm;
        height: 100vh;
        z-index: 9999;
        padding: 20px;
        background-color: #fff;
        overflow: hidden;
    }
</style>
